import { computed, ref } from 'vue'
import { alarmCategories, createPollIntervals, createPushIntervals } from './constants'
import type { CatKey, PollCfg, PushCfg } from './types'

/**
 * 推送间隔 / 轮询间隔状态。
 */
export function useIntervals() {
  const pushIntervals = ref<PushCfg[]>(createPushIntervals())

  function pushByCat(k: CatKey) {
    return pushIntervals.value.filter((p) => p.cat === k)
  }

  const categoriesWithPush = computed(() => alarmCategories.filter((c) => pushByCat(c.key).length))

  const pollIntervals = ref<PollCfg[]>(createPollIntervals())

  return {
    pushIntervals,
    pushByCat,
    categoriesWithPush,
    pollIntervals,
  }
}
